import { ApiServiceService } from './../services/api-service.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private ApiService: ApiServiceService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.ApiService.getToken();
    const bearer = this.ApiService.getToken(); // this.anyService.getToken();
  console.log('bearer==',bearer)
    if (bearer) {
      request = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${bearer}`,
        }
      });
    }
    return next.handle(request)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
          }
        }, error => {
          console.log(error);
        })
      );

  }
}
